module.exports = __webpack_public_path__ + "static/img/call-pass.b82a8331.png";